var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rj-col-3"},[_c('div',{staticClass:"rj-baseinfo"},[_c('div',{staticClass:"rj-baseinfo__label"},[_vm._v(" 订单日期： ")]),_c('div',{staticClass:"rj-baseinfo__item"},[_vm._v(" "+_vm._s(_vm.form.creattime)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }